import { Button, Tooltip } from '@fluentui/react-components'
import ActionButton from '../../../../Buttons/ActionButton'
import styles from './PanelButton.module.css'
import { ReactNode, useEffect, useState } from 'react'
import { ProgressStatus } from '../../../../StatusIndicators/ProgressStatus'

interface PanelButtonProps {
  panelText: string
  children: ReactNode
  reportIsGenerated: boolean
  panelSubmitDisabled: boolean
  panelButtonDisabled: boolean
  queriesProgress: number
  handleGenerate: () => void
  handleAbort: () => void
}

export const PanelButton = ({
  panelText,
  children,
  reportIsGenerated,
  panelSubmitDisabled,
  panelButtonDisabled,
  queriesProgress,
  handleGenerate,
  handleAbort,
}: PanelButtonProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const openPanel = () => setIsOpen(true)
  const dismissPanel = () => setIsOpen(false)

  useEffect(() => {
    if (!panelButtonDisabled) openPanel()
  }, [panelButtonDisabled])

  const openPanelButton = () => (
    <Tooltip
      content={panelButtonDisabled ? 'Laddas...' : ''}
      relationship="description"
      withArrow
      visible={panelButtonDisabled}
    >
      <ActionButton
        text={panelText}
        handleOnClick={openPanel}
        buttonStyles={['defaultButton']}
        disabled={isOpen || panelButtonDisabled}
      />
    </Tooltip>
  )

  const submitButton = () => (
    <div className={styles.buttons}>
      <Button
        onClick={handleGenerate}
        disabled={panelSubmitDisabled || reportIsGenerated}
        appearance="primary"
      >
        {panelText}
      </Button>
    </div>
  )

  const loadingIndicator = () => (
    <div className={styles.buttons}>
      <div className={styles.progressStatusContainer}>
        <ProgressStatus
          progress={queriesProgress}
          description={'Rapport skapas...'}
        />
      </div>

      {queriesProgress < 1 && (
        <Button onClick={handleAbort} appearance="secondary">
          Avbryt
        </Button>
      )}
    </div>
  )

  const submitGenerateReport = () => {
    if (reportIsGenerated) {
      return loadingIndicator()
    } else {
      return submitButton()
    }
  }

  // Note: The Panel component needs to be replaced with a FluentUI v9 equivalent
  // Temporarily keeping the structure similar but with a div instead
  return (
    <>
      {openPanelButton()}

      {isOpen && (
        <div className={styles.panel}>
          <div className={styles.panelHeader}>
            <h2>{panelText}</h2>
            <Button
              appearance="subtle"
              onClick={dismissPanel}
              aria-label="Close"
            >
              X
            </Button>
          </div>
          <div className={styles.children}>{children}</div>
          <div className={styles.panelFooter}>{submitGenerateReport()}</div>
        </div>
      )}
    </>
  )
}
